import React, { useState, useEffect ,useRef } from 'react';
import styled from 'styled-components';
import HeaderSearch from './HeaderSearch';
import HeaderMenuBtn from '../button/HeaderMenuBtn';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenMenuAction } from '../../../modules/common/headerModule';
import { useHistory } from 'react-router-dom';
import { setSearchTextAction } from '../../../modules/search/searchModule';
import {isMobileOnly, isIOS} from 'react-device-detect';
import {Helmet} from 'react-helmet-async';
const HeaderGnbMobileBlock = styled.div`
    //${isMobileOnly&&"display:flex;justify-content:space-between; flex:1; margin-left:0.5rem"};
    ${isMobileOnly&&"display:flex; align-items:center;"};
`;

const HeaderGnbMobileSearchBlock = styled.div`
    //display: inline-block;
    //position: relative;
    //margin-right: 45px;
    ${isMobileOnly&&"margin-right: 16px"};
`;

const HeaderGnbMobile = () => {

    // const [active, setActive] = useState(false);
    const [active, setActive] = useState(isMobileOnly); // 모바일인 경우 검색창 open을 디폴트값으로
    const [menuOpen, setMenuOpen] = useState(false);
    const dispatch = useDispatch();
    const [curText, setCurText] = useState("");
    const history = useHistory();
    const [scrollPostion, setScrollPostion] = useState(0);
    const inputRef = useRef(null);

    var { curMenu, searchText } = useSelector(
        ({ headerReducer, searchReducer }) => ({
            curMenu: headerReducer.curMenu,
            searchText: searchReducer.searchText,
        })
    );



    useEffect(() => {
        //#2669 스크롤 시 검색 화면 숨기기
        const onScroll = () => {
            if(active){
                if(isMobileOnly)return;
                if(Math.abs(scrollPostion - window.scrollY) > 10){
                    setActive(false);
                    if(inputRef.current){
                        inputRef.current.value = "";
                    }
                }
            }

        };
        // scroll 이벤트를 만들어줍니다. 스크롤을 움직일때 마다
        // onScroll 함수가 실행됩니다.
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [scrollPostion, active]);

    useEffect(() => {
        if(inputRef&&inputRef.current && (curMenu === 'search' || curMenu === 'searchBrand')) {
            inputRef.current.value = searchText;
        } else if(inputRef&&inputRef.current) {
            inputRef.current.value = '';
        }
    }, [searchText, curMenu]);

    const handleSearch = () => {
        // console.log("handleSearch = " + curMenu)
        // console.log("curText = " + curText)

        /* if (curMenu === 'search') {
            dispatch(setSearchTextAction(curText));
        }
        else {
            if (curText !== null && curText !== undefined && curText.length > 0) {
                // console.log("curText = " + curText);

                let tempText = curText.replace(/ /g, "");
                // console.log("tempText = " + tempText);
                if (tempText.length > 0) {
                    history.push("/search");
                    dispatch(setSearchTextAction(curText));
                }
            }
        } */
        if (curText !== null && curText !== undefined && curText.length > 0) {
            //console.log("curText = " + curText);

            let tempText = curText.replace(/ /g, "");
            // console.log("tempText = " + tempText);
            if (tempText.length > 0) {
                
                if (curMenu === 'search') {
                    history.replace("/search?q="+ curText);
                } else if (curMenu ==='searchBrand') {
                    history.replace("/searchBrand?q="+curText);
                } else {
                    history.push("/search?q="+curText);
                }
            }

            if(inputRef&&inputRef.current) {
                inputRef.current.blur();
            }
        }
    }

    const handleChangeInput = (e) => {
        setCurText(e.target.value);
    }

    const handleSearchClick = () => {
        if (active) {
            handleSearch();
        }
        setActive(!active);
        //#2669 스크롤 시 검색 화면 숨기기
        setScrollPostion(window.scrollY);
    }

    const handleCloseClick = () => {
        // console.log("handleCloseClick : " + active);
        setActive(!active);
    }

    const handleCateClick = () => {
        setMenuOpen(!menuOpen);
        dispatch(setOpenMenuAction(!menuOpen));
    }

    const getInputWidth = () =>{
        return active?(isMobileOnly?"90%":"400px"):"0px";
    }

    const getInputPadding = () =>{
        return active?(isMobileOnly?'15px 5px 15px 0':'15px 110px 15px 0'):"15px 0";
    }

    return (
        <HeaderGnbMobileBlock>
            {isIOS&&<Helmet><meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" /></Helmet>}
            <HeaderGnbMobileSearchBlock>
                <HeaderSearch onClick={handleSearch} onChange={handleChangeInput} enterPress={handleSearch} inputRef = {inputRef}/>
            </HeaderGnbMobileSearchBlock>

            <HeaderMenuBtn
                onClick={handleCateClick} />

        </HeaderGnbMobileBlock>
    );
};

export default HeaderGnbMobile;
